/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'symbol',
        type: 'string',
      },
      {
        internalType: 'address[]',
        name: 'defaultOperators',
        type: 'address[]',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'tokenHolder',
        type: 'address',
      },
    ],
    name: 'AuthorizedOperator',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'operatorData',
        type: 'bytes',
      },
    ],
    name: 'Burned',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'key',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'value',
        type: 'bytes',
      },
    ],
    name: 'DataChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'operatorData',
        type: 'bytes',
      },
    ],
    name: 'Minted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'tokenHolder',
        type: 'address',
      },
    ],
    name: 'RevokedOperator',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'operatorData',
        type: 'bytes',
      },
    ],
    name: 'Sent',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'holder',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'authorizeOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenHolder',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'dataKeys',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'defaultOperators',
    outputs: [
      {
        internalType: 'address[]',
        name: '',
        type: 'address[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_key',
        type: 'bytes32',
      },
    ],
    name: 'getData',
    outputs: [
      {
        internalType: 'bytes',
        name: '_value',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'granularity',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'tokenHolder',
        type: 'address',
      },
    ],
    name: 'isOperatorFor',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'minter',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
      {
        internalType: 'bytes',
        name: 'operatorData',
        type: 'bytes',
      },
    ],
    name: 'operatorBurn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
      {
        internalType: 'bytes',
        name: 'operatorData',
        type: 'bytes',
      },
    ],
    name: 'operatorSend',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'revokeOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'send',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'holder',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_address',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'removeMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'removeDefaultOperators',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'dataCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'allDataKeys',
    outputs: [
      {
        internalType: 'bytes32[]',
        name: '',
        type: 'bytes32[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'allTokenHolders',
    outputs: [
      {
        internalType: 'bytes32[]',
        name: '',
        type: 'bytes32[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_key',
        type: 'bytes32',
      },
      {
        internalType: 'bytes',
        name: '_value',
        type: 'bytes',
      },
    ],
    name: 'setData',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export const LSP4DigitalCertificate_bytecode =
  '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';
